export const elIds = {
  stylesheet_id: 'applepay-pm-stylesheet',
};

export const uiClasses = {
  whitePanel: 'ap-white-panel',
  paymentAmount: 'ap-payment-amount',
  applePayButton: 'ap-apple-pay-button',
  instructionalText: 'ap-instructional-text',
  subText: 'ap-sub-text',
  iconContainer: 'ap-icon-container',
};
